module.exports = __webpack_public_path__ + "e742a6b8b8e0a5bcc8c771c74806d15d.png";